// Typeahead experiments
export const HA_TYPEAHEAD_TWO_LINE_DISPLAY = 'ha_typeahead_two_line_display_v2';
export const HA_TYPEAHEAD_LID_SEARCH = 'HA_TYPEAHEAD_LID_SEARCH';
